module.exports = __webpack_public_path__ + "img/ICON_NO-AI.cbee1529.png";